import * as React from "react";
import { forwardRef } from "react";
const SvgCrossIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 13, height: 13, viewBox: "0 0 13 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12.3128 0.95023L11.3626 0L6.15642 5.21288L0.95023 0L0 0.95023L5.21288 6.15642L0 11.3626L0.95023 12.3128L6.15642 7.10665L11.3626 12.3128L12.3128 11.3626L7.10665 6.15642L12.3128 0.95023Z", fill: "#3867D6" }));
const ForwardRef = forwardRef(SvgCrossIcon);
export default ForwardRef;
